import { memo } from 'react';

import { Save, Text } from '@/components/core';
import { CheckmarkIcon, ErrorDuotoneIcon } from '@/components/icons';

export type SetupAgentProgressProps = {
  inProgress: boolean;
  inProgressMessage: string;
  doneMessage: string;
  isError?: boolean;
};

const ISetupAgentProgress = ({ inProgress, inProgressMessage, doneMessage, isError }: SetupAgentProgressProps) => {
  if (isError) {
    return (
      <div className="flex items-center justify-between">
        <Text>{inProgressMessage}</Text>
        <ErrorDuotoneIcon />
      </div>
    );
  }
  if (inProgress) {
    return <Save className="justify-between" message={inProgressMessage} />;
  }
  return (
    <div className="flex items-center justify-between">
      <Text>{doneMessage}</Text>
      <CheckmarkIcon />
    </div>
  );
};

export const SetupAgentProgress = memo(ISetupAgentProgress) as typeof ISetupAgentProgress;
